import * as React from 'react'

interface Props {
    title: string
    isConfidential: boolean
}

export function TodoItemTitle(props: Props) {
    return (
        <span className="Shared__ellipsis AppCore__ui__TodoItemTitle" data-testid="todo-item-title">
            {props.isConfidential && <zaptic-icon style={{ fontSize: '1.2rem' }} icon-name="lock" />}
            {props.title}
        </span>
    )
}
